<template>
    <div
        id="access"
        class="cabinet-settings supplier-tab hide"
        data-title="Управление доступом"
    >
        <div v-if="loading" class="supplier-settings__info">
            Loading..
        </div>
        <div v-else-if="!accesses.length" class="supplier-settings__info">
            Здесь будут отображаться запросы ритейлеров на доступ к вашим
            изделиям с ограниченной видимостью.
        </div>

        <template v-else>
            <div class="access-control__search">
                <div class="filters-panel-search">
                    <label
                        class="filters-panel-search__label"
                        for="filters-panel-search__input"
                        @click="onSearch"
                    ></label>
                    <input
                        id="filters-panel-search__input"
                        v-model="search"
                        type="text"
                        name=""
                        class="app-input filters-panel-search__input"
                        placeholder="Поиск"
                        @keyup.enter="onSearch"
                    />
                    <label
                        v-if="search"
                        class="filters-panel-search__clear"
                        for="filters-panel-search__input"
                        @click="onClearSearch"
                    ></label>
                </div>
            </div>

            <section
                class="cabinet-table-options d-flex flex-column flex-md-row justify-content-between align-items-center"
            >
                <div
                    class="order-2 order-md-1 pt-3 pt-md-0 align-self-start align-self-md-center"
                >
                    {{
                        pagination.page * pagination.pageSize +
                            1 -
                            pagination.pageSize
                    }}
                    -
                    {{
                        Math.min(
                            pagination.page * pagination.pageSize,
                            pagination.totalRecords
                        )
                    }}

                    из {{ pagination.totalRecords }}
                </div>

                <table-pagination
                    :current-page="pagination.page"
                    :total-pages="pagination.totalPages"
                    :total-products="pagination.totalRecords"
                    :classes="['order-1', 'order-md-2']"
                    @setPage="onSetPage($event)"
                />
            </section>

            <section class="cabinet-supplier-table">
                <div
                    v-for="access in accesses"
                    :key="access.BrandItemsAccessID"
                    class="cabinet-supplier-table__row d-flex flex-column flex-md-row justify-content-between"
                >
                    <div class="access-control__cell pr-2">
                        <div class="access-control__name">
                            {{ access.retailer.company_name }}
                        </div>
                        <div class="access-control__address">
                            {{ access.retailer.address || '—' }}
                        </div>
                    </div>

                    <div
                        class="access-control__cell d-flex align-items-center pr-3"
                    >
                        <span class="access-control__brand">{{
                            access.brand.BrandName
                        }}</span>
                    </div>

                    <div
                        class="access-control__cell d-flex flex-column flex-md-row justify-content-md-between align-items-md-center"
                    >
                        <template v-if="access.Status === statuses.new">
                            <button
                                class="cabinet-btn cabinet-btn--pink js-modal-toogle"
                                @click="openRejectModal(access)"
                            >
                                Отклонить запрос
                            </button>
                            <button
                                class="cabinet-btn cabinet-btn--green ml-md-2 mt-2 mt-md-0 js-modal-toogle"
                                @click="openApproveModal(access)"
                            >
                                Открыть доступ
                            </button>
                        </template>
                        <template
                            v-else-if="access.Status === statuses.approved"
                        >
                            <div
                                class="access-control__approved d-flex align-items-center"
                            >
                                <i class="icon-unlock d-inline-block mr-2 "></i>
                                Доступ открыт
                            </div>
                            <button
                                class="cabinet-btn cabinet-btn--default ml-md-2 mt-2 mt-md-0 js-modal-toogle"
                                @click="openRejectModal(access)"
                            >
                                Закрыть доступ
                            </button>
                        </template>
                    </div>
                </div>
                <!-- /cabinet-supplier-table__row  -->
            </section>

            <section
                class="cabinet-table-options d-flex justify-content-center justify-content-md-end"
            >
                <table-pagination
                    :current-page="pagination.page"
                    :total-pages="pagination.totalPages"
                    :total-products="pagination.totalRecords"
                    @setPage="onSetPage($event)"
                />
            </section>
        </template>

        <approve-modal
            :is-open="isApproveModalOpen"
            :access="selectedAccess"
            @closeModal="closeApproveModal"
            @approveModalSaved="onApproveModalSaved"
        />

        <reject-modal
            :is-open="isRejectModalOpen"
            :access="selectedAccess"
            @closeModal="closeRejectModal"
            @rejectModalSaved="onRejectModalSaved"
        />
    </div>
</template>

<script>
import TablePagination from '@/components/Cabinet/Pagination/TablePagination'
import ApproveModal from '@/components/Cabinet/Supplier/Settings/AccessModals/ApproveModal'
import RejectModal from '@/components/Cabinet/Supplier/Settings/AccessModals/RejectModal'
import _ from 'lodash'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'AccessControl',
    components: { TablePagination, ApproveModal, RejectModal },
    data() {
        return {
            loading: true,
            search: '',
            selectedAccess: {},
            isApproveModalOpen: false,
            isRejectModalOpen: false
        }
    },
    computed: {
        ...mapState('supplierAccessControl', [
            'accesses',
            'pagination',
            'errors',
            'statuses'
        ])
    },
    async mounted() {
        await this.getAccessesList()
        this.loading = false
    },
    methods: {
        ...mapActions('supplierAccessControl', ['getAccesses']),
        ...mapMutations('supplierAccessControl', ['SET_PAGINATION']),
        onSetPage(page) {
            let validPage = page
            if (page < 1) {
                validPage = 1
            } else if (page > this.pagination.totalPages) {
                validPage = this.pagination.totalPages
            }

            this.SET_PAGINATION({
                key: 'page',
                val: validPage
            })

            this.getAccessesList(page)
        },
        getAccessesList: _.debounce(async function(page = 1) {
            let data = { page }

            if (this.search) {
                this.$Progress.start()
                data.search = this.search
            }

            await this.getAccesses(data)

            if (this.search) {
                this.$Progress.finish()
            }
        }, 800),
        onSearch() {
            this.getAccessesList(1)
        },
        async onClearSearch() {
            this.search = ''
            this.$Progress.start()
            await this.getAccessesList(1)
            this.$Progress.finish()
        },
        resetSelectedAccess() {
            this.selectedAccess = {}
        },

        openApproveModal(access) {
            this.selectedAccess = access
            this.isApproveModalOpen = true
        },
        closeApproveModal() {
            this.resetSelectedAccess()
            this.isApproveModalOpen = false
        },
        onApproveModalSaved() {
            this.closeApproveModal()
            this.getAccessesList(this.pagination.page)
        },

        openRejectModal(access) {
            this.selectedAccess = access
            this.isRejectModalOpen = true
        },
        closeRejectModal() {
            this.resetSelectedAccess()
            this.isRejectModalOpen = false
        },
        onRejectModalSaved() {
            this.closeRejectModal()
            this.getAccessesList(this.pagination.page)
        }
    }
}
</script>
